








import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import { Component, Vue } from 'vue-property-decorator'
import Cookie from 'js-cookie'
import { isNotNull } from './utils/fun'
import { State, Action, Mutation } from 'vuex-class'

@Component({
  components: {},
})
export default class App extends Vue {
  @Action fetchUserInfo!: Function
  @Mutation setLogin!: Function
  @State isLogin!: boolean

  locale = zhCN

  created() {
    const token = Cookie.get('accessToken')
    if (isNotNull(token)) {
      this.fetchUserInfo()
    } else {
      this.setLogin(false)
    }
  }
}
